export const algoliaConfig = {
  hitsPerPage: '24',
  index: ['products', 'properties']
};

export const algoliaKey = {
  prod:'eb9544fe7bfe7ec4c1aa5e5bf7740feb',
  dev: '3884ebb0619b13dcec74002f555c8990',
  sandbox: '30dfe2713adb2a5e599bcb18eb89042f'
};